export enum PasswordType {
    Password = 1,
    ConfirmPassword = 2
}
